export default {
  data() {
    return {
      props: {
        'tag': '',
        'height': '150px',
        'width': '550px',
        'zIndex': 'auto',
        'maxWidth': '500px',
        'minHeight': '150px',

        'paddingTop': '5px',
        'paddingLeft': '5px',
        'paddingRight': '5px',
        'paddingBottom': '5px',

        'label' : '',

        arrowOptions: false,

        effectSlide : 'slide',

        'arrowSize' : '25px',
        'arrowColor' : '#d1d1d1',

        timerSlider: 3000,
        currentIndex: 0,
        autoPlaySlider: true,
        slider: null,
        overflow: "hidden",

        'paddingTopContainer': '5px',
        'paddingLeftContainer': '5px',
        'paddingRightContainer': '5px',
        'paddingBottomContainer': '5px',


        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'background-color': '#000000',
        'backgroundImage': 'none',/*url("photographer.jpg"); The image used */
        'backgroundPosition': 'center', /* Center the image todo this resource, not possible change at the moment */
        'backgroundOrigin': 'border-box', /* padding-box|border-box|content-box Do not repeat the image */
        'backgroundRepeat': 'no-repeat', /*repeat | repeat-x | repeat-y | no-repeat | space | round   Do not repeat the image */
        'backgroundSize': 'cover', /* 'auto | 50% | 100% 100% | cover | contain  'Resize the background image to cover the entire container */
        'borderRadius': '0 0 0 0',

        'showDesktop': true,
        'showMobile': true,

        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        }
      },
      elements: [],
      internal_config: {
        'tag': '',
        'height': '150px',
        'width': '550px',
        'zIndex': 'auto',
        'maxWidth': '500px',
        'minHeight': '150px',

        effectSlide : 'slide',

        'paddingTop': '5px',
        'paddingLeft': '5px',
        'paddingRight': '5px',
        'paddingBottom': '5px',

        arrowOptions: false,
        timerSlider: 3000,
        currentIndex: 0,
        autoPlaySlider: true,
        slider: null,
        overflow: "hidden",

        'paddingTopContainer': '5px',
        'paddingLeftContainer': '5px',
        'paddingRightContainer': '5px',
        'paddingBottomContainer': '5px',


        'border': '0 none #000000',
        'boxShadow': '0 0 0 0 black initial',
        'background-color': '#000000',
        'backgroundImage': 'none',/*url("photographer.jpg"); The image used */
        'backgroundPosition': 'center', /* Center the image todo this resource, not possible change at the moment */
        'backgroundOrigin': 'border-box', /* padding-box|border-box|content-box Do not repeat the image */
        'backgroundRepeat': 'no-repeat', /*repeat | repeat-x | repeat-y | no-repeat | space | round   Do not repeat the image */
        'backgroundSize': 'cover', /* 'auto | 50% | 100% 100% | cover | contain  'Resize the background image to cover the entire container */
        'borderRadius': '0 0 0 0',

        'showDesktop': true,
        'showMobile': true,

        'label' : '',
        'arrowSize' : '25px',
        'arrowColor' : '#d1d1d1',

        'animation': {
          'in': {
            'action': 'time',   //time/scroll/click/hover
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'speed': 'slow',
            'infinite': false,
          },
          'out': {
            'action': 'time',   //time/scroll/click
            'time': 0,       // sec
            'scroll': 0,     // px
            'effect': 'none',
            'delay': '1',
            'speed': '1',
            'infinite': false,
          },
        }
      },
      name:
        'slidergroup',
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/apps/SliderDropGallery/SliderGroup/Model.js